
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiDcdcConverter as ObiDcdcConverterElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-dcdc-converter.js';
 
 
 

 
 export const ObiDcdcConverter = createComponent({
   react: React,
   tagName: 'obi-dcdc-converter',
   elementClass: ObiDcdcConverterElement,
   events: {
     
   }
  });
 
 